<template>
    <el-dialog class="dialog dialog-mini" :visible="dialogs.referenceInformation" customClass="dialog_main dialog-mini_main" :append-to-body="true" @open="handleOpen" :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner dialog__head-inner_justify-left mb-24">
                <h3 class="dialog__title">{{ title }}</h3>

                <template v-if="user.role_id === 1">
                    <button v-if="!openEditWysiwyg" type="button" class="edit-btn ml-12" @click.prevent.stop="openWysiwyg">
                        <icon-base viewBox="0 0 18 18" iconColor="#000000" class="edit-btn__icon">
                            <icon-edit />
                        </icon-base>
                    </button>

                    <button v-else type="button" class="change-btn change-btn-dialog-header ml-12" @click.prevent="saveChanges">
                        Сохранить изменения
                    </button>
                </template>
            </div>
            <div class="divider"></div>
        </div>

        <div slot="default" class="dialog__inner">
            <div v-if="!openEditWysiwyg" class="dialog__content dialog__content_wysiwyg" v-html="content"></div>

            <template v-else>
                <quill-editor v-model="editReferenceInformation" />
            </template>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { quillEditor } from 'vue-quill-editor'

import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    props: {
        content: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: 'Справка'
        },
        hintsCode: {
            type: String,
            default: ''
        }
    },
    components: {
        quillEditor
    },
    data() {
        return {
            editReferenceInformation: '',
            openEditWysiwyg: false
        }
    },
    methods: {
        ...mapActions('hints', [
            'LOAD_HINTS',
            'UPDATE_HINTS',
        ]),
        
        openWysiwyg() {
            this.openEditWysiwyg = true
        },

        closeDialog() {
            this.openEditWysiwyg = false
            this.elDialogs.referenceInformation = false;
        },
        async handleOpen() {
            if (this.hintsCode.length !== 0) await this.LOAD_HINTS(this.hintsCode)
            this.editReferenceInformation = this.content
        },
        async saveChanges() {
            const params = {
                hint_code: this.hintsCode,
                data: {
                    title: 'Справка',
                    content: this.editReferenceInformation
                }
            }
            await this.UPDATE_HINTS(params)
            await this.LOAD_HINTS(this.hintsCode)

            this.openEditWysiwyg = false
        },
    },
    computed: {
         ...mapState('user', ['user']),
    }
}
</script>
